module.exports = __webpack_public_path__ + "static/media/logo.5e88a5f5.bin";